// ADMIN-NAV-AZ-001 (Sep 2026): Admin Portal sidebar ordering — presentation only.
// Input = the already-RBAC-filtered sections from AdminLayout.getNavItems().
const PINNED_NAV_SECTIONS = ['Overview'];
const byLabel = (a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' });

/** Pure: pinned sections first (given order), then sections A→Z with items A→Z. Never mutates input. */
export const alphabetizeAdminNav = (sections) => {
  const pinned = PINNED_NAV_SECTIONS.map(name => sections.find(s => s.section === name)).filter(Boolean);
  const rest = sections.filter(s => !PINNED_NAV_SECTIONS.includes(s.section)).slice().sort((a, b) => byLabel(a.section, b.section));
  return [...pinned, ...rest].map(s => ({ ...s, items: (s.items || []).slice().sort((a, b) => byLabel(a.label, b.label)) }));
};
